enum SituacaoRemuneracaoEnum {
  Divergente = 'Divergente',
  Pendente = 'Pendente',
  Validada = 'Validada',
  ValidacaoPendente = 'ValidacaoPendente',
  Paga = 'Paga',
  Provisionada = 'Provisionada',
  EnviadoParaPagamento = 'EnviadoParaPagamento',
}

export default SituacaoRemuneracaoEnum
